import { z } from 'zod';

import { type RouteExportParams } from '~/types/router.type';

export const validateSearch = z.object({
  companyId: z.uuid().optional(),
});

export const routeParams: RouteExportParams = {
  permissions: ['company.'],
};
